package com.example.hukakmp.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window

@Composable
actual fun rememberExternalUrlOpener(): (String) -> Unit = remember {
    { url: String ->
        val opened = window.open(url, "_blank", "noopener,noreferrer")
        opened?.asDynamic()?.opener = null
    }
}
